import { getLink } from "../../../utils/utils";

const content = {
	esp: (
		`
		<p class="mb-3">
			Kion Esperanto donis al mi?
		</p>
		
		<p class="mb-3">
			Nu, unue - la ĝojon vidi la mondon. 
			Mi nenie havas parencojn, eĉ en mia lando; sed dank’ al Esperanto mi vizitis 14 landojn en 3 kontinentoj, kaj ĉie mi estis akceptita varme kaj kore, ĉie mi ĝuis la sinceran amikecon. 
			Mi parolis la saman lingvon kun miaj gastigantoj, mi loĝis en iliaj domoj, kaj tial mi perceptis la vivon ne kiel hastanta turisto, sed kvazaŭ la enloĝanto de la lando; mi povis mem vidi, kompreni, analizi, kaj interŝanĝi miajn opiniojn kun plej diversaj homoj sen ajna lingva bariero. 
			Krom ekkono de la mondo, tio estas unika ebleco ekkoni ankaŭ sin mem kaj homajn rilatojn, pensojn, ideojn… 
			Mi certas, ke neniu lingvo, krom Esperanto, donas tiun eblecon libere, senpere kaj senbare interkomunikiĝi.
		</p>
		
		<p class="mb-3">
			Kaj se paroli pri pli konkretaj aferoj, ne romantikaj, sed pure vivrealaj, kiuj gravas por plimulto de homoj, do Esperanto helpis al mi ekposedi aliujn fremdajn lingvojn. 
			Post mia unua Esperanta tendaro (SEJT), kiam mi dum 10 tagoj parolis, pensis, sonĝis en Esperanto, mi, tiam 20-jara, decidis eklerni ankoraŭ iun fremdan lingvon, por kontroli, ĉu nur Esperanto tiel facile percepteblas – aŭ ĉu mi povus enkapigi aliun fremdan lingvon, jam kun komplika gramatiko kaj multaj esceptoj. 
			Kiam mi ekposedis la hispanan, kiun mi ekamis per la tuta animo, mi decidis kontroli, ĉu sukcesos mi kun la lingvo, kiu tre ne plaĉas al mi – la germana. 
			Post kiam mi jam havis bazon de kelkaj lingvoj, mi povis sen speciala lernado kompreni la francan, portugalan, italan, polan ktp. 
			Sed komenciĝis ĉio ekde Esperanto, kiu malfermis al mi la vojon kaj donis fidon al miaj propraj fortoj.
		</p>
		
		<p class="mb-3">
			Kaj tria – denove romantika – Esperanto donis al mi multajn amikojn, donis komunumon, kie mi sentas min sekura kaj protektita. 
			Tio estas mia «referrent group», al kiu mi povas konfidi miajn pensojn, verkojn, ideojn. 
			Dum en mia lando okazas katastrofoj, Esperantujo vivas per sia propra, trankvila vivo (mi temas ne pri desupraj diskutoj, sed pri kutima vivo de ordinaraj anoj, bonkoraj kaj agrablaj homoj).
		</p>
		
		<p class="mb-3">
			Jes, Esperanto estas utopio – sed utopio reala, ĉiam ekzistanta apud nia kutima mondo; kaj mi ĝojas, ke ĝiaj pordegoj iam malfermiĝis por mi!
		</p>
		`
	)
}

const itemName = {
	esp: 'Kion Esperanto donis al mi'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp:{
		itemName: itemName.esp,
		itemContent: content.esp
	}
}

export default item;